<template>
  <div id="content">
    <h1>Painel Financeiro em construção</h1>
  </div>
</template>

<script>

export default {
    name: "FinancialPanel",
    components: {

    }
}
</script>

<style lang="scss" scoped>

</style>